import { getSessionCompanyCountryCode } from './session';

export const getFeatures = state => state.entities.features;
export const getFeature = (state, featureName) =>
  state?.entities?.features?.[featureName];
export const getIsFeatureEnabled = (state, featureName) =>
  Boolean(state?.entities?.features?.[featureName]);
export const getFeatureVariant = (state, featureName) =>
  state?.entities?.features?.[featureName]?.variant?.value;
// The variant NAME ("base", "experiment"), as opposed to getFeatureVariant
// above, which reads the variant's optional payload. The name is the only
// thing that says which arm of an A/B a company landed in; the flag being
// present does not, because Unleash returns it for control and treatment
// alike.
export const getFeatureVariantName = (state, featureName) =>
  state?.entities?.features?.[featureName]?.variant?.name;
export const getIsFeatureVariant = (state, featureName, variantName) =>
  getFeatureVariantName(state, featureName) === variantName;
export const getIsFeatureEnabledInCountry = (state, featureName) =>
  getFeatureVariant(state, featureName)
    ?.split(',')
    ?.includes(getSessionCompanyCountryCode(state));
export const areFeaturesFetched = state => state?.features?.isFetched;
export const getAreFeaturesFetched = areFeaturesFetched;
export const getShowFeatureLoadingModal = state =>
  state?.features?.showLoadingModal;
